<template>
  <div class="recharge-agreement-page">
    
    <div style="width: 100%; height: 65px; position: fixed; background-color: black;"></div>
    <div class="container">
      <h1 class="title">中青网用户充值协议</h1>
      <!-- <p class="subtitle">生效日期：2025-11-04（最近更新）</p> -->

      <div class="card">
        <p>感谢您使用中青网的充值服务。本《用户充值协议》（以下简称“本协议”）是您（或“用户”）与中青网之间就充值、虚拟币（“硬币”）购买与使用等相关事项所订立的有效协议。请务必在充值前仔细阅读并充分理解本协议的全部内容，尤其是<strong>费用结算、虚拟币性质、退款规则、未成年人条款、风险与合规</strong>等条款。</p>
        <p>您点击“同意”或进行充值操作，即视为已阅读并同意本协议全部内容。</p>
      </div>

      <div class="section">
        <h2>一、适用范围</h2>
        <ol>
          <li>本协议适用于您在中青网网站（含后续可能提供的 H5/移动端等形态）进行的充值与消费行为。</li>
          <li>中青网有权根据业务需要对本协议进行修订与更新，并以站内公告或页面提示等方式公布并生效。<strong>若您不同意更新内容，应立即停止充值与使用；若您继续使用，即视为接受更新后的协议。</strong></li>
        </ol>
      </div>

      <div class="section">
        <h2>二、账户与安全</h2>
        <ol>
          <li>您应使用具备完全民事行为能力的账户进行充值并妥善保管账号与支付工具。<strong>因保管不当导致的损失由您自行承担。</strong></li>
          <li>如发现异常登录、异常扣费或其他安全风险，请立即联系中青网客服处理。</li>
        </ol>
      </div>

      <div class="section">
        <h2>三、充值与“硬币”说明</h2>
        <ol>
          <li>中青网采用虚拟币“硬币”作为平台内付费内容与服务的结算单位，<strong>硬币不具法定货币属性</strong>，不可在平台外流通或进行兑现、转让（法律法规另有规定或中青网另行公告的除外）。</li>
          <li>充值比例：<strong>1 元 = 10 硬币</strong>（示例，实际以页面公示为准）。首次充值返利活动（如：<strong>首充 1:10 赠送</strong>）以平台实时活动规则为准。</li>
          <li>内容定价示例：
            <ul>
              <li>音乐素材：约 10—30 硬币/个（以页面具体标价为准）。</li>
              <li>漫画章节：约 190 硬币/话（以页面具体标价为准）。</li>
            </ul>
          </li>
          <li>充值成功后，硬币将记入您的账户余额并可用于解锁/购买平台内容或服务。<strong>余额及消费记录以系统记载数据为准。</strong></li>
        </ol>
      </div>

      <div class="section">
        <h2>四、支付方式与发票</h2>
        <ol>
          <li>您应通过平台支持的官方渠道完成支付（如：第三方支付机构、银行卡等），并保证资金来源合法。</li>
          <li>若您需要发票，请按平台指引在规定时间内提交开票申请。发票类型、抬头与开票周期以国家税法及平台规则为准。</li>
        </ol>
      </div>

      <div class="section">
        <h2>五、消费生效与权益</h2>
        <ol>
          <li>当您使用硬币解锁/购买内容或服务时，系统通常会即时生效并在您的账户内展示相应权益（如已解锁章节、已购素材）。</li>
          <li>部分权益可能具有使用期限、授权范围或设备限制，具体以购买页面或对应服务说明为准。</li>
        </ol>
      </div>

      <div class="section">
        <h2>六、退款与异常处理</h2>
        <ol>
          <li><strong>充值成功的硬币一般不支持退款或提现</strong>；已使用硬币解锁/购买的内容或服务，原则上不支持退换。</li>
          <li>如出现重复扣费、长时间未到账、系统故障等异常情况，请在合理时间内联系客服并提供订单号、支付凭证等材料以便核查处理。</li>
          <li>对于涉嫌违规、欺诈或违法所得的交易，中青网有权采取冻结、取消订单、回退权益、封禁账户等处理措施，并依法配合相关部门调查。</li>
        </ol>
      </div>

      <div class="section">
        <h2>七、活动与赠送</h2>
        <ol>
          <li>您参与的充值返利、限时赠送、优惠券等活动以活动页面/规则为准。<strong>赠送的虚拟权益可能设有有效期、使用范围或其他限制条件。</strong></li>
          <li>如发现非正常方式参与活动（包括但不限于外挂、批量注册、恶意套利等），中青网有权取消相关资格并追究责任。</li>
        </ol>
      </div>

      <div class="section">
        <h2>八、未成年人条款</h2>
        <ol>
          <li>未成年人应在监护人监护、指导下进行充值与消费，<strong>充值前应取得监护人明确同意</strong>。监护人应妥善保管支付工具与账户信息。</li>
          <li>如发生未经授权的充值，请监护人第一时间联系客服并配合提供证明材料以便核查。</li>
        </ol>
      </div>

      <div class="section">
        <h2>九、风险提示与责任限制</h2>
        <ol>
          <li>由于网络、第三方支付、系统维护等原因可能导致充值或到账延迟、失败；我们将积极协助核查，但<strong>不对所有外部原因引发的损失承担责任</strong>。</li>
          <li>在法律允许的范围内，中青网对您因使用充值服务产生的间接、偶然、特殊、惩罚性或后果性损害不承担责任。中青网承担的总体赔偿责任，以您在相关争议发生前连续六个月内为充值服务实际支付的对价为上限。</li>
        </ol>
      </div>

      <div class="section">
        <h2>十、协议变更与终止</h2>
        <ol>
          <li>中青网有权根据业务需要对本协议进行调整，并以公告或页面提示的方式通知您。</li>
          <li>如您存在违规、违法或损害平台与他人合法权益的行为，中青网有权暂停或终止向您提供充值与相关服务。</li>
        </ol>
      </div>

      <div class="section">
        <h2>十一、争议解决与适用法律</h2>
        <ol>
          <li>本协议的订立、效力、解释、履行及争议解决，适用中华人民共和国法律。</li>
          <li>双方因本协议产生的争议，优先友好协商解决；协商不成的，提交中青网所在地有管辖权的人民法院诉讼解决。</li>
        </ol>
      </div>

      <div class="section">
        <h2>十二、联系我们</h2>
        <ul>
          <li>客服邮箱：zqwzbs@126.com</li>
          <li>工作时间：每日 9:00-22:00（法定节假日照常）</li>
        </ul>
      </div>

      <div class="card foot">
        <p>提示：继续充值或使用即表示您已阅读并同意本《中青网用户充值协议》。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RechargeAgreement',
}
</script>

<style scoped lang="scss">
.recharge-agreement-page { background:#fff; color:#0f172a; }
.container { max-width: 900px; margin: 0 auto; padding: 92px 16px 60px; }
.title { margin:0; font-size: 32px; font-weight: 800; letter-spacing: -.3px; }
.subtitle { margin: 6px 0 16px; color:#64748b; }

.card { background:#fff; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin-bottom: 14px; }
.card.foot { background:#f8fafc; }

.section { background:#fff; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin-bottom: 14px; }
.section h2 { margin:0 0 10px; font-size: 16px; font-weight: 800; color:#0f172a; }
.section p { margin: 8px 0; color:#334155; line-height: 1.75; }
.section ol, .section ul { margin: 8px 0 0 18px; color:#334155; line-height: 1.75; }
.section li { padding-left: 4px; }

@media (max-width: 520px) {
  .container { padding: 88px 12px 40px; }
  .title { font-size: 24px; }
}
</style>
